import { ListHeading } from "@/components/shared/list-header";
import { View, CardContent, Card, Button } from "@/components/ui";
import { ShoppingCart } from "@/components/shared/icons";
import { Divider } from "@/components/shared/divider";
import React from "react";
import { OrderDetails } from "./order-details";
import { useBookingState } from "@/store/booking/useBookingState";
import { Typography } from "../../typography";
import type { IconNames } from "../../icons/icon-map";

export const BookingOrderCard = ({
  buttonText = "Continue",
  loading,
  disabled,
  extraInfo,
  onContinue,
  icon = "arrowRight",
  iconAlignment = "end",
}: {
  loading?: boolean;
  disabled?: boolean;
  buttonText?: string;
  extraInfo?: React.ReactElement;
  onContinue?: () => void;
  icon?: IconNames;
  iconAlignment?: "start" | "end";
}) => {
  const {
    data: { selectedPackageIds },
  } = useBookingState();
  return (
    <Card>
      <CardContent className="native:pt-0 p-4">
        <ListHeading title="Your Order" icon={ShoppingCart} />
        <Divider className="my-2" />
        {!selectedPackageIds.length ? (
          <View className="flex flex-col items-center justify-center gap-2 py-8">
            <ShoppingCart
              size={40}
              className="text-foreground-attenuated"
              weight="fill"
            />
            <Typography color="foreground-intermediate" variant="body-sm">
              No items selected
            </Typography>
          </View>
        ) : (
          <>
            <OrderDetails showTotal />
            {extraInfo}
          </>
        )}
        <Button
          variant="primary"
          color="CTA"
          loading={loading}
          fullWidth="full"
          iconAlignment={iconAlignment}
          iconName={icon}
          onClick={onContinue}
          disabled={disabled}
          children={buttonText}
        />
        <Typography
          variant="caption-md"
          color="brand-primary"
          align="center"
          className="mx-4 mt-3"
        >
          No payment required now. Invoice issued after service completion
        </Typography>
      </CardContent>
    </Card>
  );
};
